// externals
import type { FC, KeyboardEvent } from 'react';

// libraries
import { PriceInput } from '@makemydeal/dr-shared-components/price-input';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { ColumnMapping, InputChangeInterstateEventHandler } from '../manualAccessoriesTypes';

// consts/enums
import * as deskingConstants from '../../../constants';

export type ManualAccessoryInstallFieldStateProps = {
    disabled: boolean;
    index: number;
    install: string;
    installColumnMapping: ColumnMapping<number>;
    hasError?: boolean;
    errorMessage?: string;
};

export type ManualAccessoryInstallFieldDispatchProps = {
    handleInputChange: InputChangeInterstateEventHandler;
    handleOnBlur: (fieldName: string) => void;
    handleKeyPress: (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>, fieldName: string) => void;
};

export type ManualAccessoryInstallFieldProps = ManualAccessoryInstallFieldStateProps & ManualAccessoryInstallFieldDispatchProps;

export const ManualAccessoryInstallField: FC<ManualAccessoryInstallFieldProps> = ({
    disabled,
    index,
    install,
    installColumnMapping: { fieldName },
    handleInputChange,
    handleOnBlur,
    handleKeyPress,
    hasError,
    errorMessage
}) => {
    return (
        <PriceInput
            sx={{ minWidth: '108px' }}
            size="sm"
            allowDecimal={true}
            displayLabel={true}
            data-testid={`${fieldName}-${index}`}
            label={deskingConstants.INSTALL}
            className="base-accessories-label"
            name={`${fieldName}-${index}`}
            onChange={(e) => {
                handleInputChange(e, fieldName);
            }}
            onBlur={() => {
                handleOnBlur(fieldName);
            }}
            onKeyDown={(e) => {
                handleKeyPress(e, fieldName);
            }}
            value={install}
            disabled={disabled}
            hasError={hasError}
            errorMessage={errorMessage}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};
